// Used: S/W. Return Shopify Product with each variants
export const transformShopifyProducts = shopifyProducts => {
    const products = []
    shopifyProducts.forEach(product => {
        const { variants } = product
        variants.forEach(variant => {
            const newProduct = { ...product }
            Object.entries(variant).forEach(([key, value]) => {
                newProduct[`variant-${key}`] = value
            })
            products.push(newProduct)
        })
    })
    return products
}
